import gql from 'graphql-tag';

export default gql`
  mutation removeByIdEventMutation($_id: MongoID!) {
    removeByIdEventMutation(_id: $_id) {
      record {
        _id
      }
    }
  }
`;
